/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MySQLLeadIntegrationInput
 */
export interface MySQLLeadIntegrationInput {
    /**
     * 
     * @type {string}
     * @memberof MySQLLeadIntegrationInput
     */
    hostname?: string;
    /**
     * 
     * @type {string}
     * @memberof MySQLLeadIntegrationInput
     */
    port?: string;
    /**
     * 
     * @type {string}
     * @memberof MySQLLeadIntegrationInput
     */
    username?: string;
    /**
     * 
     * @type {string}
     * @memberof MySQLLeadIntegrationInput
     */
    password?: string;
    /**
     * 
     * @type {string}
     * @memberof MySQLLeadIntegrationInput
     */
    tableName?: string;
    /**
     * 
     * @type {string}
     * @memberof MySQLLeadIntegrationInput
     */
    domain?: string;
    /**
     * 
     * @type {string}
     * @memberof MySQLLeadIntegrationInput
     */
    customWhere?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MySQLLeadIntegrationInput
     */
    databaseName?: string;
    /**
     * 
     * @type {string}
     * @memberof MySQLLeadIntegrationInput
     */
    columnDate?: string;
    /**
     * 
     * @type {string}
     * @memberof MySQLLeadIntegrationInput
     */
    timeZone?: string;
    /**
     * 
     * @type {string}
     * @memberof MySQLLeadIntegrationInput
     */
    columnCountry?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MySQLLeadIntegrationInput
     */
    columnVerified?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MySQLLeadIntegrationInput
     */
    categoryColumns?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MySQLLeadIntegrationInput
     */
    columnUtmSource?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MySQLLeadIntegrationInput
     */
    columnUtmMedium?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MySQLLeadIntegrationInput
     */
    columnUtmContent?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MySQLLeadIntegrationInput
     */
    columnClickId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MySQLLeadIntegrationInput
     */
    columnUtmCampaign?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MySQLLeadIntegrationInput
     */
    columnUtmCampaignId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MySQLLeadIntegrationInput
     */
    columnUtmAdSetId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MySQLLeadIntegrationInput
     */
    columnUtmAdSetAdId?: string | null;
}

/**
 * Check if a given object implements the MySQLLeadIntegrationInput interface.
 */
export function instanceOfMySQLLeadIntegrationInput(value: object): value is MySQLLeadIntegrationInput {
    return true;
}

export function MySQLLeadIntegrationInputFromJSON(json: any): MySQLLeadIntegrationInput {
    return MySQLLeadIntegrationInputFromJSONTyped(json, false);
}

export function MySQLLeadIntegrationInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): MySQLLeadIntegrationInput {
    if (json == null) {
        return json;
    }
    return {
        
        'hostname': json['hostname'] == null ? undefined : json['hostname'],
        'port': json['port'] == null ? undefined : json['port'],
        'username': json['username'] == null ? undefined : json['username'],
        'password': json['password'] == null ? undefined : json['password'],
        'tableName': json['tableName'] == null ? undefined : json['tableName'],
        'domain': json['domain'] == null ? undefined : json['domain'],
        'customWhere': json['customWhere'] === undefined ? undefined : json['customWhere'] === null ? null : json['customWhere'],
        'databaseName': json['databaseName'] == null ? undefined : json['databaseName'],
        'columnDate': json['columnDate'] == null ? undefined : json['columnDate'],
        'timeZone': json['timeZone'] == null ? undefined : json['timeZone'],
        'columnCountry': json['columnCountry'] === undefined ? undefined : json['columnCountry'] === null ? null : json['columnCountry'],
        'columnVerified': json['columnVerified'] === undefined ? undefined : json['columnVerified'] === null ? null : json['columnVerified'],
        'categoryColumns': json['categoryColumns'] === undefined ? undefined : json['categoryColumns'] === null ? null : json['categoryColumns'],
        'columnUtmSource': json['columnUtmSource'] === undefined ? undefined : json['columnUtmSource'] === null ? null : json['columnUtmSource'],
        'columnUtmMedium': json['columnUtmMedium'] === undefined ? undefined : json['columnUtmMedium'] === null ? null : json['columnUtmMedium'],
        'columnUtmContent': json['columnUtmContent'] === undefined ? undefined : json['columnUtmContent'] === null ? null : json['columnUtmContent'],
        'columnClickId': json['columnClickId'] === undefined ? undefined : json['columnClickId'] === null ? null : json['columnClickId'],
        'columnUtmCampaign': json['columnUtmCampaign'] === undefined ? undefined : json['columnUtmCampaign'] === null ? null : json['columnUtmCampaign'],
        'columnUtmCampaignId': json['columnUtmCampaignId'] === undefined ? undefined : json['columnUtmCampaignId'] === null ? null : json['columnUtmCampaignId'],
        'columnUtmAdSetId': json['columnUtmAdSetId'] === undefined ? undefined : json['columnUtmAdSetId'] === null ? null : json['columnUtmAdSetId'],
        'columnUtmAdSetAdId': json['columnUtmAdSetAdId'] === undefined ? undefined : json['columnUtmAdSetAdId'] === null ? null : json['columnUtmAdSetAdId'],
    };
}

export function MySQLLeadIntegrationInputToJSON(json: any): MySQLLeadIntegrationInput {
    return MySQLLeadIntegrationInputToJSONTyped(json, false);
}

export function MySQLLeadIntegrationInputToJSONTyped(value?: MySQLLeadIntegrationInput | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'hostname': value['hostname'],
        'port': value['port'],
        'username': value['username'],
        'password': value['password'],
        'tableName': value['tableName'],
        'domain': value['domain'],
        'customWhere': value['customWhere'],
        'databaseName': value['databaseName'],
        'columnDate': value['columnDate'],
        'timeZone': value['timeZone'],
        'columnCountry': value['columnCountry'],
        'columnVerified': value['columnVerified'],
        'categoryColumns': value['categoryColumns'],
        'columnUtmSource': value['columnUtmSource'],
        'columnUtmMedium': value['columnUtmMedium'],
        'columnUtmContent': value['columnUtmContent'],
        'columnClickId': value['columnClickId'],
        'columnUtmCampaign': value['columnUtmCampaign'],
        'columnUtmCampaignId': value['columnUtmCampaignId'],
        'columnUtmAdSetId': value['columnUtmAdSetId'],
        'columnUtmAdSetAdId': value['columnUtmAdSetAdId'],
    };
}

